;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { cn } from '@workspace/ui/lib';

interface ListItemProps {
  title: string;
  id: string;
  value?: string;
  onChange?: (id: string) => void;
  icon?: React.ReactNode;
  titleDescription?: string;
  actionDescription?: string;
  actionItems?: React.ReactNode;
  hasPointerEvents?: boolean;
}
const ListItem = ({
  id,
  value,
  title,
  icon,
  titleDescription,
  actionDescription,
  actionItems,
  hasPointerEvents = false,
  onChange,
}: ListItemProps) => {
  const isSelected = value === id;

  return (
    <div
      className="group border-grey-200 dark:border-grey-700 border-b"
      key={id}
      onClick={hasPointerEvents && onChange ? () => onChange(id) : undefined}
      role={hasPointerEvents && onChange ? 'button' : undefined}
      tabIndex={hasPointerEvents && onChange ? 0 : undefined}
      onKeyDown={
        hasPointerEvents && onChange
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onChange(id);
              }
            }
          : undefined
      }
      aria-selected={isSelected}
    >
      <div
        className={cn(
          'group flex justify-between',
          hasPointerEvents
            ? 'hover:bg-grey-100 dark:hover:bg-grey-900 my-2 cursor-pointer rounded-2xl px-3 py-3'
            : 'pt-3 pb-4',
          isSelected && hasPointerEvents && 'bg-grey-100 dark:bg-grey-900'
        )}
      >
        <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
          {icon && <div className="shrink-0">{icon}</div>}
          {titleDescription ? (
            <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
              <p
                className={cn(
                  'text-grey-800 dark:text-grey-300 min-w-0 flex-1 truncate text-base leading-5 font-normal',
                  hasPointerEvents &&
                    'group-hover:font-medium group-hover:text-neutral-200 dark:group-hover:text-neutral-100',
                  isSelected && 'font-medium text-neutral-200 dark:text-neutral-100'
                )}
                title={title}
              >
                {title}
              </p>
              <p
                className="text-grey-600 dark:text-grey-200 shrink-0 text-sm leading-5 font-normal whitespace-nowrap"
                title={titleDescription}
              >
                {titleDescription}
              </p>
            </div>
          ) : (
            <p
              className={cn(
                'text-grey-800 dark:text-grey-300 text-base leading-5 font-normal',
                hasPointerEvents &&
                  'group-hover:font-medium group-hover:text-neutral-200 dark:group-hover:text-neutral-100',
                isSelected && 'font-medium text-neutral-200 dark:text-neutral-100'
              )}
            >
              {title}
            </p>
          )}
        </div>
        <div className="flex h-7 items-center gap-2 align-middle">
          {actionDescription && (
            <div className="text-grey-800 dark:text-grey-300 text-sm leading-none font-normal">
              {actionDescription}
            </div>
          )}
          {actionItems && actionItems}
        </div>
      </div>
    </div>
  );
};

export { ListItem };
